export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '„Endlich Material, das ich ohne Vorbereitung einsetzen kann."',
    name: 'Sabine K.',
    role: 'Grundschullehrerin',
  },
  {
    quote: '„Meine Klasse ist so viel motivierter — die Aktivitäten sind toll."',
    name: 'Markus T.',
    role: 'Musiklehrer',
  },
  {
    quote: '„Perfekt für den fachfremden Einsatz. Klar und verständlich."',
    name: 'Julia R.',
    role: 'Klassenlehrerin',
  },
  {
    quote:
      '„Ein kompletter Lehrplan von Klasse 1 bis 9 — genau das, was ich brauchte."',
    name: 'Andreas W.',
    role: 'Sekundarstufe',
  },
  {
    quote: '„Die Lernkontrollen und Lösungen sparen mir enorm viel Zeit."',
    name: 'Petra M.',
    role: 'Musikschule',
  },
  {
    quote: '„Druckbar, digital, sofort einsetzbar — ich bin begeistert."',
    name: 'Nina H.',
    role: 'Homeschooling',
  },
]
